import { DialogTitle } from '@mui/material';
import SimpleDrawDlg from '../../SimpleDrawDlg/SimpleDrawDlg';
import { useTranslation } from 'react-i18next';

import { RecipientAddForm } from './RecipientAddForm';
import { Signer } from '../../../features/providers/TaskCreationProvider/useTaskCreate';

interface Props {
  open: boolean;
  onClose: () => void;
  signers: Signer[];
  onDone: (signers: Signer[]) => void;
}
export const AddRecipientSignModal = (props: Props) => {
  const { t } = useTranslation();

  return (
    props.open && (
      <SimpleDrawDlg
        open={props.open}
        handleClose={props.onClose}
        maxWidth="md"
      >
        <DialogTitle variant="h3">
          {t('addRecipientSignatureTitle', { ns: 'taskbox' })}
        </DialogTitle>
        <RecipientAddForm
          signers={props.signers}
          onSubmit={(data) => {
            props.onDone(data);
            props.onClose();
          }}
          onClose={props.onClose}
        />
      </SimpleDrawDlg>
    )
  );
};
